import React from 'react';

// Context for all available gift cards for a merchant
const GCAvailableContext = React.createContext();

export const GCAvailableProvider = GCAvailableContext.Provider;
export const GCAvailableConsumner = GCAvailableContext.Consumer;
export default GCAvailableContext;